import {
  DEFAULT_COLORS,
  NODE_HEIGHT,
  NODE_WIDTH
} from './constants.js';

export function drawGrid(ctx, offset, width, height) {
  ctx.save();
  ctx.translate(offset.x % 40, offset.y % 40);
  ctx.beginPath();
  ctx.strokeStyle = 'rgba(15, 23, 42, 0.025)';
  ctx.lineWidth = 1;

  for (let x = -40; x < width + 40; x += 40) {
    ctx.moveTo(x, -40);
    ctx.lineTo(x, height + 40);
  }

  for (let y = -40; y < height + 40; y += 40) {
    ctx.moveTo(-40, y);
    ctx.lineTo(width + 40, y);
  }

  ctx.stroke();
  ctx.restore();
}

export function drawConnections(ctx, nodes, connections, frame) {
  connections.forEach(connection => {
    const start = nodes.find(node => node.id === connection.from);
    const end = nodes.find(node => node.id === connection.to);
    if (!start || !end) return;

    const cp1 = { x: start.x + ((end.x - start.x) / 2), y: start.y };
    const cp2 = { x: start.x + ((end.x - start.x) / 2), y: end.y };

    ctx.beginPath();
    ctx.moveTo(start.x, start.y);
    ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, end.x, end.y);
    ctx.strokeStyle = DEFAULT_COLORS.brand100;
    ctx.lineWidth = 2;
    ctx.setLineDash(connection.dashed ? [8, 8] : []);
    ctx.lineDashOffset = -frame * 0.25;
    ctx.stroke();
    ctx.setLineDash([]);

    if (!connection.dashed) {
      const position = bezierPoint((frame * 0.006) % 1, start, cp1, cp2, end);
      ctx.beginPath();
      ctx.arc(position.x, position.y, 3, 0, Math.PI * 2);
      ctx.fillStyle = DEFAULT_COLORS.brand400;
      ctx.fill();
    }
  });
}

export function drawNodes(ctx, nodes, hoveredNode, selectedNode = null) {
  nodes.forEach(node => {
    const isHovered = hoveredNode === node;
    const isSelected = selectedNode === node;
    const width = NODE_WIDTH;
    const height = NODE_HEIGHT;

    ctx.save();
    ctx.shadowBlur = isHovered || isSelected ? 30 : 0;
    ctx.shadowColor = 'rgba(15, 23, 42, 0.14)';
    roundRect(ctx, node.x - (width / 2), node.y - (height / 2), width, height, 24);
    ctx.fillStyle = isHovered || isSelected ? node.color : '#ffffff';
    ctx.fill();
    ctx.strokeStyle = isHovered || isSelected ? node.color : DEFAULT_COLORS.brand100;
    ctx.lineWidth = isSelected ? 2.5 : 1.5;
    ctx.stroke();
    ctx.shadowBlur = 0;

    ctx.font = '900 10px Inter, system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.fillStyle = isHovered || isSelected ? 'rgba(255,255,255,0.7)' : node.color;
    ctx.fillText(String(node.phase).toUpperCase(), node.x, node.y - 14);

    ctx.font = '700 14px Inter, system-ui, sans-serif';
    ctx.fillStyle = isHovered || isSelected ? '#ffffff' : DEFAULT_COLORS.brand900;
    ctx.fillText(truncateLabel(node.label), node.x, node.y + 10);
    ctx.restore();
  });
}

function roundRect(ctx, x, y, width, height, radius) {
  if (typeof ctx.roundRect === 'function') {
    ctx.beginPath();
    ctx.roundRect(x, y, width, height, radius);
    return;
  }

  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x, y, radius);
  ctx.arcTo(x, y, x + width, y, radius);
  ctx.closePath();
}

function bezierPoint(t, p0, p1, p2, p3) {
  const cx = 3 * (p1.x - p0.x);
  const bx = 3 * (p2.x - p1.x) - cx;
  const ax = p3.x - p0.x - cx - bx;
  const cy = 3 * (p1.y - p0.y);
  const by = 3 * (p2.y - p1.y) - cy;
  const ay = p3.y - p0.y - cy - by;

  return {
    x: (ax * (t ** 3)) + (bx * (t ** 2)) + (cx * t) + p0.x,
    y: (ay * (t ** 3)) + (by * (t ** 2)) + (cy * t) + p0.y
  };
}

function truncateLabel(label) {
  const value = String(label);
  return value.length > 28 ? `${value.slice(0, 25)}...` : value;
}
